export default {
  title: 'My orders',
  subtitle: 'Track delivery, reveal keys, and download invoices.',

  filter: {
    aria: 'Filter orders',
    all: 'All',
    keys: 'Keys',
    topups: 'Top-ups',
  },

  table: {
    item: 'Item',
    date: 'Date',
    status: 'Status',
    amount: 'Amount',
    actions: 'Actions',
  },

  noMatch: 'Nothing here for this filter.',

  empty: {
    title: 'No orders yet.',
    body: 'Once you check out, your purchases will show up here with delivery status and key reveal.',
    cta: 'Browse catalog',
  },

  row: {
    qty: 'qty {n}',
    wallet: 'Wallet',
    walletTopup: 'Wallet funds top-up',
    viewOrder: 'View order',
    downloadReceipt: 'Invoice PDF',
  },

  detail: {
    invoiceNote: 'Paid from your wallet. The invoice belongs to the top-up that funded it:',
    invoiceLink: 'Billing › Invoices',
    title: 'Order {ref}',
    notFound: 'Order not found',

    keys: {
      title: 'Your keys',
      encrypted: 'Keys are encrypted at rest. Click reveal to view — your access is logged.',
      reveal: 'Reveal keys',
    },

    note: {
      PENDING: 'This order is being processed. This page updates automatically.',
      FAILED: 'This order could not be completed.',
      REFUNDED: 'This order was refunded.',
    },

    totals: {
      unitPrice: 'Unit price',
      quantity: 'Quantity',
      total: 'Total',
    },

    timeline: {
      title: 'Timeline',
    },
  },
};
